import React from 'react';
import { Heading, Message } from '@lumx/react';
import { mdiCheckCircle } from '@mdi/js';
import MdiIcon from '@mdi/react';
import { useWizard } from '../context/WizardContext';

const PostDeploymentPage: React.FC = () => {
  const { deploymentDate } = useWizard();

  const fmtDate = (d: Date) => {
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
  };

  return (
    <div className="main-content" style={{ overflow: 'auto' }}>
      <div className="page-header">
        <div className="page-header-left">
          <Heading as="h1" typography="headline">Company structure</Heading>
        </div>
      </div>

      <div style={{ padding: '48px 24px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, maxWidth: 640, margin: '0 auto', textAlign: 'center' }}>
        <MdiIcon path={mdiCheckCircle} size={2.5} color="var(--lumx-color-green-N)" />
        <Heading as="h2" typography="title">Governance migration complete</Heading>
        {deploymentDate && (
          <p style={{ color: 'rgba(0,0,0,0.60)', fontSize: 14 }}>
            Deployed on {fmtDate(deploymentDate)}
          </p>
        )}

        <Message kind="info" hasBackground style={{ textAlign: 'left', marginTop: 8 }}>
          <strong>Coming soon:</strong> After deployment, this view will become the standard company structure overview, with an org hierarchy tree on the left and a graphical view option. This screen is not yet designed.
        </Message>

        <div style={{
          width: '100%', marginTop: 8, border: '2px dashed rgba(0,0,0,0.12)', borderRadius: 8,
          padding: '40px 24px', color: 'rgba(0,0,0,0.38)', fontSize: 13
        }}>
          Company structure view · placeholder
        </div>
      </div>
    </div>
  );
};

export default PostDeploymentPage;
